import React from 'react';
import ColorMastersProvider from './color-masters-provider';

export default function withColorMasters(WrappedComponent) {
  return function ColorMastersProviderHOC(props) {
    return (
      <ColorMastersProvider>
          <WrappedComponent {...props} />
      </ColorMastersProvider>
    );
  };
};
